import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CompanyDeletionRequestEffects } from './deletion-request.effects';
import {
  CompanyDeletionRequestNamespace,
  CompanyDeletionRequestReducer,
} from './deletion-request.store';

@NgModule({
  imports: [
    StoreModule.forFeature(CompanyDeletionRequestNamespace, CompanyDeletionRequestReducer),
    EffectsModule.forFeature([CompanyDeletionRequestEffects]),
  ],
})
export class CompanyDeletionRequestDataModule {}
